import { useContext } from 'react';
import { ServiceMultiSelectionContext } from '../ServiceMultiSelectionContext';
import { useMessagingDrawer } from 'restaurantAdmin/messaging/hooks';
import { isReservation } from '../apiHelpers';
import type { ServiceReservation, ServiceWalkIn } from '../apiHelpers';
import { groupBy } from 'lodash-es';

export const useMultiSelectOccupants = () => {
  const {
    multiSelectionOccupantCount,
    isMultiSelectingOccupants,
    multiSelectedOccupants,
    toggleMultiSelection: toggleMultiSelectingOccupants,
    isOccupantMultiSelected,
    updateOccupantMultiSelection,
    updateOccupantMultiSelectionGroup,
  } = useContext(ServiceMultiSelectionContext);
  const { openMessagingDrawer } = useMessagingDrawer();

  const messageSelectedOccupants = () => {
    const groupedOccupants = groupBy(multiSelectedOccupants, (o) =>
      isReservation(o) ? 'guest' : 'walkIn',
    );

    const serviceReservations = groupedOccupants.guest as ServiceReservation[];
    const serviceWalkIns = groupedOccupants.walkIn as ServiceWalkIn[];
    const guestIds = [...new Set(serviceReservations?.map((o) => o.guest.id))];
    const walkInIds = [...new Set(serviceWalkIns?.map((o) => o.id))];

    openMessagingDrawer(guestIds, walkInIds);
  };

  return {
    multiSelectionOccupantCount,
    isMultiSelectingOccupants,
    toggleMultiSelectingOccupants,
    isOccupantMultiSelected,
    updateOccupantMultiSelection,
    messageSelectedOccupants,
    updateOccupantMultiSelectionGroup,
  };
};
